import { inject, Injectable } from '@angular/core';
import { AppFontSize } from 'src/app/enums/app-font-size.enum';
import { BrowserService } from './browser.service';
import { formatFontSizeClassName } from 'src/app/utils/format-font-size-class-name.util';

const fontSizeAnimationTime = 300;

@Injectable()
export class FontControlService {
  private readonly browserService = inject(BrowserService);

  public setAppFontSizeClass(fontSize: AppFontSize): void {
    this.browserService.removeHtmlElementClass(
      [AppFontSize.SMALL, AppFontSize.MEDIUM, AppFontSize.LARGE].map(fontSize => formatFontSizeClassName(fontSize))
    );

    this.browserService.setHtmlElementClass(formatFontSizeClassName(fontSize));

    setTimeout(() => window.dispatchEvent(new Event('resize')), fontSizeAnimationTime);
  }
}
